import { useMemo } from 'react';

import { extractLoomIds } from '../loomEmbed';

/** Display-only: render a Loom player for each Loom link found in `html`.
 *  Read-side only — the description doc/editor is untouched; the raw link still
 *  shows above (this just adds the inline player). Loom-only, by design. */
export function LoomEmbeds({ html }: { html?: string | null }) {
  const ids = useMemo(() => extractLoomIds(html), [html]);
  if (ids.length === 0) return null;

  return (
    <div className="space-y-3">
      {ids.map((id) => (
        <div
          key={id}
          className="relative aspect-video w-full overflow-hidden rounded-md border"
        >
          <iframe
            src={`https://www.loom.com/embed/${id}`}
            title="Loom video"
            className="absolute inset-0 size-full"
            allow="fullscreen; picture-in-picture"
            allowFullScreen
            referrerPolicy="strict-origin-when-cross-origin"
          />
        </div>
      ))}
    </div>
  );
}
